import { NSARouterMakerResult } from "namirasoft-account-react";
import { JournalEntryFullRow, JournalEntryInputRow, JournalEntryRow } from "namirasoft-erp";
import { Component } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeMode } from "../ErpScope";
import { JournalEntryLinesView } from "../components/JournalEntryLinesView";

interface JournalEntryViewPageProps extends NSARouterMakerResult, ErpRouterProps { }

export default class JournalEntryViewPage extends Component<JournalEntryViewPageProps>
{
    override render()
    {
        return (
            <ErpLayout<JournalEntryRow, JournalEntryInputRow>
                {...this.props}
                mode={ErpScopeMode.None}
                pages={{
                    entity: ErpEntities.journal_entry(this.props),
                    view: {
                        ui: {
                            getChildrenAfter: (id, row) =>
                            {
                                if (!row || !id)
                                    return null;
                                let row_full = row as JournalEntryFullRow;
                                let firstCurrencyId = row_full.lines.find((r) => !!r.currency_id)?.currency_id ?? "";
                                let isMulti = row_full.lines.some((r) => r.currency_id && r.currency_id !== firstCurrencyId);
                                let entryCurrencyId = isMulti ? "" : firstCurrencyId;
                                return (
                                    <JournalEntryLinesView
                                        {...this.props}
                                        journal_entry_id={id}
                                        currency_id={entryCurrencyId}
                                        rows={row_full.lines}
                                        mode={row_full.mode}
                                    />
                                );
                            },
                        },
                    },
                }}
            ><></></ErpLayout>
        );
    }
}